export class ForbiddenException extends Error {
  public readonly statusCode: number = 403;
}
